/**
 * Extended version of normal MyPlaylistsCtrl
 */
angular.module('pitch.app')
.controller('FeaturedPlaylistCtrl',
    function ($scope, $rootScope, content, $controller, $state) {
        'use strict';

        $scope.content = content;

        //this needs to have the same structure as a loader (so that the directive can
        //understand the data)
        $scope.playlistItems = {
            data: content.subject.items
        };

        // We used to extend the base PlaylistLandingCtrl, but no more...
        // angular.extend(this, $controller('PlaylistLandingCtrl', {
        //     $scope: $scope,
        //     playlist: content.subject
        // }));
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/FeaturedPlaylistCtrl.js